module.exports = __webpack_public_path__ + "media/images/card_logos/unkown-logo-00ca9a1101c32046aaee59e931555a40.png";